import { render } from "./tinymceMsg.vue?vue&type=template&id=aa2e5406"
import script from "./tinymceMsg.vue?vue&type=script&setup=true&lang=js"
export * from "./tinymceMsg.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/var/www/vhosts/elyosdigital.com/_build/workspace/MySchool/myschool.elyosdigital.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/tinymceMsg.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "aa2e5406"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('aa2e5406', __exports__)) {
    console.log('reload')
    api.reload('aa2e5406', __exports__)
  }
  
  module.hot.accept("./tinymceMsg.vue?vue&type=template&id=aa2e5406", () => {
    console.log('re-render')
    api.rerender('aa2e5406', render)
  })

}


export default __exports__